'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MEDIA_TYPES = exports.MEDIA_TYPES = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    RICH: 'RICH',
    MAP: 'MAP',
    DOC: 'DOC',
    PDF: 'PDF'
};

var RESIZEABLE_MEDIA = exports.RESIZEABLE_MEDIA = [MEDIA_TYPES.IMAGE, MEDIA_TYPES.VIDEO, MEDIA_TYPES.AUDIO, MEDIA_TYPES.RICH, MEDIA_TYPES.MAP, MEDIA_TYPES.PDF];


//////////////////
// WEBPACK FOOTER
// ./src/common/links/richMediaConstants.js
// module id = 483
// module chunks = 0